<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-4">
          <label>Date de début</label>
          <datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-4">
          <label>Date de fin</label>
          <datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-4">
          <label class="control-label">Société</label>
          <v-select
            v-model="filters.merchant"
            :options="merchantsOptions"
            @input="updateConceptsOptions"
          ></v-select>
        </div>
        <div class="form-group col-sm-4">
          <label>Concept</label>
          <v-select v-model="filters.concept" :options="concepts">
            <span slot="no-options">Sélectionnez une option pour Société.</span>
          </v-select>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters()"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },

  props: {
    default: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      filters: {},
      conceptsOptions: [],
    };
  },

  computed: {
    ...mapState({
      concepts: (state) => state.concepts,
      merchants: (state) => state.merchants,
    }),

    merchantsOptions() {
      return this.merchants.map((merchant) => {
        return { label: merchant.name, value: merchant.id };
      });
    },
  },

  created() {
    this.filters = this.default;
  },

  methods: {
    applyFilters() {
      this.$emit("update", this.filters);
    },

    updateConceptsOptions(merchant) {
      this.conceptsOptions = [];
      this.filters.concept = null;

      if (merchant?.value) {
        this.conceptsOptions = this.concepts
          .filter((c) => c.merchantId === merchant.value)
          .map((c) => {
            return {
              value: c.id,
              label: c.name,
            };
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
